import YoutubeManager from './YoutubeManager'


export default
{
    name: 'app-youtube',

    props:
    {
        id: {type: String, default: null},
        autoplay: {type: Boolean, default: true},
        mute: {type: Boolean, default: false}
    },

    mounted()
    {
        if (!this.id)
        {
            console.error('<app-youtube> need and id')
        }
        else
        {
            // enablejsapi=1
            this.player = new YoutubeManager(this.id, this.$el.querySelector('.js-youtube'), {
                autoplay: this.autoplay,
                mute: this.mute,
                onReady: this._onReady,
                onError: this._oError,
                onPlay: this._onPlay,
                onPause: this._onPause
            })
        }
    },

    destroyed()
    {
        this.player.destroy()
    },

    methods:
    {
        _onReady()
        {
            this.$emit('ready', this.player)
        },

        _onError()
        {
            this.$emit('error', this.player)
        },

        _onPlay()
        {
            this.$emit('play', this.player)
        },

        _onPause()
        {
            this.$emit('pause', this.player)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-youtube/script.js